import type { Type } from "@angular/core";

export class HeaderRendererItem {
  constructor(public component: Type<unknown>) {}
}
